<template>
  <div>
    <slot
      :creditShown="creditShown"
      :toggleCredit="toggleCredit"
      :$id="$id"
    ></slot>
  </div>
</template>

<script lang="js">
export default  {
  name: 'ahc-exhibition-image',
  data() {
    return {
      creditShown: false
    }
  },
  methods: {
    toggleCredit() {
      this.creditShown = !this.creditShown;
    },
    hideCredit() {
      this.creditShown = false;
    }
  }
}
</script>
